// Genuine KhozaLand product photographs supplied by the business.
// All are real phone photographs of finished items (not AI mockups).
// NOTE: several show personal names / organisation emblems - customer permission must be
// confirmed before launch (see launch checklist).

const build = (slug, ratio) => ({
  src: `/images/${slug}-md.webp`,
  srcSet: `/images/${slug}-sm.webp 480w, /images/${slug}-md.webp 800w, /images/${slug}-lg.webp 1220w`,
  large: `/images/${slug}-lg.webp`,
  ratio,
});

export const MEDIA = {
  blanketRhudulu: {
    ...build("ingcawe-blanket-rhudulu-clan", 830 / 915),
    alt: "White Ingcawe blanket with black stripes, personalised by KhozaLand with the Rhudulu clan name, clan praises and illustrated leopard, eagle, shield and lion motifs",
  },
  blanketMngwevu: {
    ...build("ingcawe-blanket-mngwevu-clan", 1046 / 915),
    alt: "Personalised white Ingcawe blanket printed in black with the Mngwevu clan name, a leopard illustration and clan praises",
  },
  golfShirtClan: {
    ...build("custom-golf-shirt-clan-name-print", 1220 / 915),
    alt: "Back of a white golf shirt custom printed in black with a clan name and a traditional rondavel illustration",
  },
  cushionsTote: {
    ...build("personalised-cushions-tote-bag", 1220 / 915),
    alt: "Two personalised birthday photo cushions and a personalised printed tote bag made by KhozaLand",
  },
  mugsEvent: {
    ...build("branded-mugs-community-event", 686 / 915),
    alt: "Stack of six white mugs personalised with individual names and a commemorative community event design",
  },
  candlesChurch: {
    ...build("personalised-candles-church-event", 1220 / 915),
    alt: "Five white pillar candles personalised with names, an event date and scripture verses for a church women's event",
  },
};

export const GALLERY_CATEGORIES = [
  { value: "all", label: "All work" },
  { value: "custom-clothing", label: "Custom Clothing" },
  { value: "uniforms", label: "Uniforms" },
  { value: "corporate-gifts", label: "Corporate Gifts" },
  { value: "personalised", label: "Personalised Products" },
  { value: "xhosa-cultural", label: "Xhosa Cultural Products" },
  { value: "promotional-printing", label: "Promotional Printing" },
];

export const GALLERY = [
  {
    id: "ingcawe-rhudulu",
    title: "Personalised Ingcawe Blanket — Rhudulu",
    category: "xhosa-cultural",
    categoryLabel: "Xhosa Cultural Products",
    media: MEDIA.blanketRhudulu,
    description: "A white Ingcawe blanket personalised with a clan name, clan praises (iziduko) and illustrated motifs.",
    enquiry: { category: "xhosa-cultural", product: "Ingcawe / Ngcawe Blanket" },
    whatsapp: "cultural",
    type: "Completed work",
  },
  {
    id: "golf-shirt-clan",
    title: "Clan-Name Printed Golf Shirt",
    category: "custom-clothing",
    categoryLabel: "Custom Clothing",
    media: MEDIA.golfShirtClan,
    description: "A white golf shirt with a custom back print combining a clan name and a traditional rondavel illustration.",
    enquiry: { category: "custom-clothing", product: "Golf T-Shirt" },
    whatsapp: "tshirts",
    type: "Completed work",
  },
  {
    id: "mugs-event",
    title: "Commemorative Event Mugs",
    category: "corporate-gifts",
    categoryLabel: "Corporate Gifts",
    media: MEDIA.mugsEvent,
    description: "A set of mugs for a community event, each personalised with an individual name and the event design.",
    enquiry: { category: "corporate-gifts", product: "Branded Mugs" },
    whatsapp: "corporate",
    type: "Completed work",
  },
  {
    id: "cushions-tote",
    title: "Personalised Cushions & Tote Bag",
    category: "personalised",
    categoryLabel: "Personalised Products",
    media: MEDIA.cushionsTote,
    description: "Birthday photo cushions and a personalised tote bag featuring names, photographs and messages.",
    enquiry: { category: "personalised-gifts", product: "Personalised Cushion" },
    whatsapp: "gifts",
    type: "Completed work",
  },
  {
    id: "ingcawe-mngwevu",
    title: "Personalised Ingcawe Blanket — Mngwevu",
    category: "xhosa-cultural",
    categoryLabel: "Xhosa Cultural Products",
    media: MEDIA.blanketMngwevu,
    description: "An Ingcawe blanket printed with a clan name, a leopard illustration and clan praises.",
    enquiry: { category: "xhosa-cultural", product: "Ingcawe / Ngcawe Blanket" },
    whatsapp: "cultural",
    type: "Completed work",
  },
  {
    id: "candles-church",
    title: "Personalised Church Event Candles",
    category: "personalised",
    categoryLabel: "Personalised Products",
    media: MEDIA.candlesChurch,
    description: "Pillar candles personalised with names, a date and scripture verses for a church women's event.",
    enquiry: { category: "personalised-gifts", product: "Personalised Candles" },
    whatsapp: "gifts",
    type: "Completed work",
  },
];
